var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"pill":"","variant":_vm.signatureTypeColor}},[_vm._v("\n    "+_vm._s(_vm.signatureTypeText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }